export const xLauncherTypeHeader = 'BROWSER_FORM';
